const modules = import.meta.glob<{ default: string }>('./kolovraty2-*.jpg', { eager: true });

export const kolovraty2Images = Object.keys(modules)
  .sort((a, b) => {
    const na = parseInt(a.match(/kolovraty2-(\d+)/)?.[1] || '0');
    const nb = parseInt(b.match(/kolovraty2-(\d+)/)?.[1] || '0');
    return na - nb;
  })
  .map(k => modules[k].default);

import fp1np3d from './fp-1np-3d.jpg';

export const kolovraty2FloorPlans = [
  { image: fp1np3d, label: "1. NP – 3D" },
];
